import { getGroupPermissionFactory } from '../../../common';
import { getOrderManagementModuleName } from './order-management.permissions';

export class OrderManagementEndUserPermissions {
  static GroupName = `${getOrderManagementModuleName()}.EndUsers`;
  
    static getPermissions = getGroupPermissionFactory(OrderManagementEndUserPermissions.GroupName);
    static Permissions = {}
}
